export default __webpack_public_path__ + "static/media/svg-2.0bd0cf47.svg";